import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as T from './PlayedDuration.types';
import * as S from './PlayedDuration.styles';
import { formatDuration } from './helpers';
import * as SL from 'modules/Player/selectors';

export class PlayedDuration extends PureComponent<T.IPlayedDurationProps, T.IPlayedDurationState> {
  state = {
    isRemainingDuration: false,
  };

  onShowRemainingDurationToggle = () => {
    this.setState((prevState) => {
      return {
        isRemainingDuration: !prevState.isRemainingDuration,
      };
    });
  };

  render() {
    const { durationPlayedInSeconds, trackDuration } = this.props;
    const { isRemainingDuration } = this.state;

    const duration = isRemainingDuration
      ? Math.floor(trackDuration - durationPlayedInSeconds)
      : durationPlayedInSeconds;

    return (
      <S.PlayedDurationWrapper
        className="noselect"
        data-testid="PlayedDuration"
        onClick={this.onShowRemainingDurationToggle}
      >
        {formatDuration({
          duration,
          isRemainingDuration: isRemainingDuration,
        })}
      </S.PlayedDurationWrapper>
    );
  }
}

const mapStateToProps = (state: any) => ({
  trackDuration: SL.getCurrentlyPlayingTrackDuration(state),
  durationPlayedInSeconds: SL.getDurationPlayedInSeconds(state),
});

export default connect(mapStateToProps, null)(PlayedDuration);
